var map = {
	"./Dashboard_icon_white.svg": 523,
	"./Inspection_job_report_white.svg": 524,
	"./Manage_roles_white.svg": 525,
	"./Manage_users_icon_white.svg": 526,
	"./assign_Transfer_job_white.svg": 527,
	"./cloud_icon_01_white.svg": 528,
	"./create_inspection_job_white.svg": 529,
	"./industry_white.svg": 530,
	"./inspection_dashboard_white.svg": 531,
	"./onboard_new_plant_white.svg": 532,
	"./truck-transporter_white.svg": 533
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1125;